<template>
  <select-dialog
    ref="selectDialog"
    :title="$t('CargoMsg.Cargo_SelectOperationInstruction')"
    :row-data="rowData"
    :column-defs="columnDefs"
    :filter-keys="['instructionName']"
    :value="platformInstructionUuid"
    :event-name="eventName"
    :filter-label="$t('CargoMsg.Cargo_InstructionName')"
    display-name-field="instructionName"
    @change="changeTrigger"
  />
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { SE } from '@/class/cargo/model/parameters/SystemConstants'
// import { queryAllPlatformInstructionByTenant } from '@/api/sysManage/baseConfig/instruction'
import SelectDialog from '@/components/SelectDialog'
export default {
  name: 'PlatformInstructionDialog',
  components: { SelectDialog },
  props: {
    lob: {
      type: String,
      default: () => SE.code
    },
    platformInstructionUuid: {
      type: String,
      default: () => ''
    },
    platformInstructions: { type: Array, default: () => [] }, // 平台 操作指令
    instructionType: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      rowData: [],
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_InstructionName'),
          field: 'instructionName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionType'),
          field: 'instructionType',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.instructionTypeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_RuleCode'),
          field: 'ruleCode',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CodeParameterValues'),
          field: 'codeParamDescription',
          width: 200
        }, {
          headerName: this.$t('SeaExport.descr'),
          field: 'remark',
          width: 200
        }
      ],
      eventName: ''
    }
  },
  watch: {
    instructionType() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    changeTrigger(data) {
      this.$emit('change', data)
    },
    init() {
      this.rowData = []
      this.eventName = ''
      if (this.$refs.selectDialog) {
        this.$refs.selectDialog.displayName = ''
      }
      if (this.platformInstructions && this.platformInstructions.length > 0) {
        this.rowData = this.platformInstructions.filter(p => p.lobs.indexOf(this.lob) > -1 && (p.instructionType === this.instructionType || p.uuid === this.platformInstructionUuid))
        if (this.rowData && this.rowData.length > 0 && this.platformInstructionUuid) {
          const platformInstruction = this.rowData.find(item => item.uuid === this.platformInstructionUuid)
          if (platformInstruction) {
            this.eventName = platformInstruction.instructionName
          }
        }
      }
    }
  }
}
</script>
